<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Search:">
										<el-select v-model="stationid" clearable filterable placeholder="Search" size="medium" style="width:100%;">
											<el-option v-for="item3 in spbu.list" :key="item3.StationId" :label="item3.StationName" :value="item3.StationId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>

								<div class="col-md-6">
									<!--<ReportParamDateRange title="Date" v-model="date" />-->
									<el-form-item label="Transaction Date:">
										<div class="block">
											<el-date-picker
												v-model="dateRange"
												type="daterange"
												align="right"
												size="small" 
												unlink-panels
												range-separator="-"
												start-placeholder="Start date"
												end-placeholder="End date"
												format="yyyy-MM-dd"
												value-format="yyyy-MM-dd"
												:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName == 'vehicle_transaction'">
									<el-form-item label="Count Trans:">
										<el-select v-model="countTrans" clearable filterable placeholder="Select Count Trans" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.countTrans" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							
							</div>

							<div class="row">
								<div class="col-md-6" v-if="tabName != 'latest_transaction'">
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>

							<!--
							<div class="row" v-if="tabName=='outlet'">
								<div class="col-md-6">
									<el-form-item label="Detail:">
										<el-select v-model="detail" clearable filterable placeholder="Select Detail" size="medium" style="width:100%;">
											<el-option v-for="item3 in options.detail" :key="item3.value" :label="item3.name" :value="item3.value">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								
								<div class="col-md-6" >
									<el-form-item label="Active:">
										<el-radio-group v-model="active" size="small" name="active">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.active" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							
							</div>
							-->
								
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			
			<div class="mt-0">
				<ReportResultTable :reportname="'FuelJbtReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 	
			</div>

		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import ReportResultTableWithFooter from '@/views/pages/ReportResultTable3WithFooter.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Fuel,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		//ReportResultTableWithFooter,
		//LineChart,
		//BarChart,
		
	},

	data(){
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().mingguSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			urlRequestParams: '',
			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "station", name: "BY STATION" }, 
					//{ value: "tank", name: "BY TANK" }, 
				],
				detail2:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "ProductGroup" }, 
					{ value: "product", name: "BY PRODUCT", field: "ProductName" },
				],
				detail3:[
					{ value: "", name: "ALL" }, 
					{ value: "cash", name: "BY CASH" }, 
					{ value: "payment", name: "BY METHOD" },
				],
				area:[
					{ value: "", name: "ALL" }, 
					//{ value: "area", name: "BY AREA", field: "SalesArea" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					//{ value: "by_owner", name: "BY OWNER" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				lokasi:[
					{ value: "", name: "ALL" }, 
					//{ value: "by_location", name: "BY LOCATION" }, 
					{ value: "TOL", name: "TOL" }, 
					{ value: "NON TOL", name: "NON TOL" }, 
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "NORMAL", name: "NORMAL" }, 
					{ value: "LOW", name: "LOW" }, 
					{ value: "CRITICAL", name: "CRITICAL" }, 
				],
				active:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "INACTIVE" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					//{ value: 'by_station_type', name: 'BY STATION TYPE' },
					{ value: 'SPBU', name: 'SPBU' },
					{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					{ value: 'SPBU-T', name: 'SPBU-T' },
					{ value: 'SHELTER', name: 'SHELTER' },
					{ value: 'MODULAR', name: 'MODULAR' },
				],

				detail:[
					{ value: "", name: "Detail Per Station" }, 
					{ value: "area", name: "Rekap Per Area" }, 
					{ value: "type", name: "Rekap Per Type" }, 
					{ value: "area_type", name: "Rekap Per Type Per Area" }, 
					{ value: "hose", name: "Rekap Nozzle" }, 
					{ value: "area_hose", name: "Rekap Nozzle Per Area" }, 
					{ value: "station_hose", name: "Rekap Nozzle Per Station" }, 
					{ value: "pos", name: "Detail Pos" }, 
				],
				presentation:[
					{ value: "1", name: "Table" }, 
					{ value: "9", name: "Chart" }, 
					{ value: "8", name: "Map" }, 
				],
				years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                ],
				countTrans:[
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
				],
			},

			//tabIndex: this.$route.query.tab ? this.$route.query.tab : 0, 
			charttype: 'linechart', //barchart //linechart
			reportdata: [],
			chartdata: [],
			countTrans: '',
			reportdatasummarygradingpertaminaway: [],
			showchart: false,
			stacked: true,
			showtype: 'value', //value, percentage
			showtypesc: 'value', //value, percentage
			dateRange: [], //[this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			monthRange:[],
			city:'',
			presentation:'1',
			detail:'',
			outletcharttype: 'chartbygrowth',
			active:'',
			totalValue: '',
			reportdatachart: [],

			plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : '',
			period: this.$route.query.period ? this.$route.query.period : 'daily',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			detail2: this.$route.query.detail2 ? this.$route.query.detail2 : 'product',
			detail3: this.$route.query.detail3 ? this.$route.query.detail3 : '',
			area: this.$route.query.area ? this.$route.query.area : '',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',

			year: '2023',

			loading: {
				table: false,
				chart: false,
				isSuccess: false,
				tableSummaryGradingPertaminaWay: false,
				isSuccessSummaryGradingPertaminaWay: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			pickerOptionsMonth: {
				shortcuts: [
					{
						text: 'This month',
						onClick(picker) {
							picker.$emit('pick', [new Date(), new Date()]);
						}
					}, 
					{
						text: 'This year',
						onClick(picker) {
							const end = new Date();
							const start = new Date(new Date().getFullYear(), 0);
							picker.$emit('pick', [start, end]);
						}
					}, 
					{
						text: 'Last 6 months',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(start.getMonth() - 6);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},

		}
	},
	watch:
	{
		//date(){ this.resumePilihan() },
		//plantno() { this.resumePilihan() },
		//stationid() { this.resumePilihan() },
		reportdata() { this.refreshChart(); },
		reportdatachart() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
		showtype() { this.refreshChart(); },
		showtypesc() { this.refreshChart(); },
		outletcharttype() { this.refreshChart(); },
		//stationtype(){ this.resumePilihan() },

	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
		if(this.tabIndex == 3) {
			let tankFilter = { value: "tank", name: "BY TANK" };
			this.options.detail1.push(tankFilter);
		}

		if(this.tabIndex == 4 || this.tabIndex == 5 || this.tabIndex == 6) {
			let addOptionsItemOwner = { value: "by_owner", name: "BY OWNER" };
			let addOptionsItemType = { value: 'by_station_type', name: 'BY STATION TYPE' };
			let addOptionsItemLocation = { value: "by_location", name: "BY LOCATION" }
			//this.options.owner.push(addOptionsItemOwner);
			//this.options.types.push(addOptionsItemType);
			//this.options.lokasi.push(addOptionsItemLocation);

			this.options.owner.splice(1, 0, addOptionsItemOwner);
			this.options.types.splice(1, 0, addOptionsItemType);
			this.options.lokasi.splice(1, 0, addOptionsItemLocation);
		}

		if(this.tabName =='outlet') {
			this.detail1 = 'station'
			this.stacked = false
			this.charttype = 'barchart'
			
			//remove daily
			/*
			this.options.period = [
					{ value: '', name: 'ALL' },
					//{ value: 'daily', name: 'DAILY' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				]
			*/
			let elementToRemove = { value: 'daily', name: 'DAILY' };
			let indexToRemove = this.options.period.findIndex(obj => obj.value === elementToRemove.value);
			if (indexToRemove !== -1) {
				this.options.period.splice(indexToRemove, 1);
			}

			this.period = 'monthly'
			this.dateRange = [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin]
			this.resumePilihanChart()
		} else if(this.tabName == 'rkap_vs_realisasi') {
			this.monthRange = [Penanggalan().tahunSekarang,Penanggalan().kemarin]
		} else if(this.tabName == 'grading_station') {
			this.area = ''
			this.getSummaryGradingPertaminaWay()
		} else if(this.tabName == 'grading_station_summary') {
			this.area = ''
		} else if(this.tabName =='margin_tac') {
			this.area = ''
			this.monthRange = [Penanggalan().bulanSekarang,Penanggalan().kemarin]
		}  else if(this.tabName =='hose_delivery') {
			this.area = ''
			this.dateRange = [Penanggalan().bulanSekarang,Penanggalan().sekarang]
		}

        this.$emit('childrenRoute');
		this.loadStationList()
		this.resumePilihan()
		
    },
    methods:{
		refreshChart() {
			let opt = this.getoption(this.detail2, this.options.detail2)
			let a = opt && opt.field ? opt.field : ""
			
			opt = this.getoption(this.area, this.options.area)
			a = opt && opt.field ? opt.field : a
			
			let b = "Period"
			let c = (a == "ProductName") ? FuelColor : Rainbow
			if (this.tabIndex == 4 || this.tabIndex == 5) {
				let valuecol = 'DifferenceSalesVolume';
				if(this.showtype == 'percentage') {
					valuecol = 'SalesVolumePercentage';
					this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.showtype == 'value') {
					this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
				} else {
					let chartdatacomparison = []
					this.reportdata.data.forEach((item) => {
						//console.log('item: '+JSON.stringify(item));
						let monthA = {
							label: item.label,
							legend: 'Month 1',
							value: item.SalesVolume0,
						};
						chartdatacomparison.push(monthA)

						let monthB = {
							label: item.label,
							legend: 'Month 2',
							value:  item.SalesVolume,
						};
						chartdatacomparison.push(monthB)

					});

					this.chartdata = this.processBarChart(chartdatacomparison, "legend", "", "value", false, "label", "", 1, 2, c, false, false, false, this.stacked);
				}
					
				
			} else if(this.tabIndex == 6) {
				let valuecol = 'SalesVolume';
				if(this.showtypesc == 'percentage')
					valuecol = 'Percentage';
				this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
			} else if(this.tabIndex == 7) {
				let valuecol = 'PerformBBM';
				this.chartdata = this.processBarChart(this.reportdata.data, "legend", "", valuecol, false, "label", "", 1, 2, c, false, false, false, this.stacked);
			} else if(this.tabIndex == 8) {
				c = Rainbow
				let valuecol = 'Jumlah'
				let legend = 'SalesArea'
				let label = ''
				let prefix = ''

				if(this.outletcharttype == 'chartbygrowth') {
					//empty
					prefix = ''
					legend = 'legend'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowtharea') {
					//empty
					prefix = 'AREA '
					legend = 'SalesArea'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowthowner') {
					//empty
					prefix = ''
					legend = 'OwnershipType'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbygrowthtype') {
					//empty
					prefix = ''
					legend = 'StationType'
					label = 'period'
					/*
					const sum = this.reportdata.data
							.map(item => item.Cnt)
							.reduce((prev, curr) => prev + curr, 0);
							//console.log('sum: ' + sum)
					*/
					this.totalValue = '' //sum
					this.chartdata = this.processBarChart(this.reportdatachart.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbyarea') {
					this.totalValue = ''
					//empty
					prefix = 'Area '
					legend = 'SalesArea'
					label = ''
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbytype') {
					this.totalValue = ''
					//empty
					prefix = ''
					legend = 'StationType'
					label = ''
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				} else if(this.outletcharttype == 'chartbyperiod') {
					this.totalValue = ''
					//empty
					prefix = ''
					legend = 'legend'
					label = 'period'
					valuecol = 'Cnt'
					this.chartdata = this.processBarChart(this.reportdata.data, legend, prefix, valuecol, false, label, "", 1, 2, c, false, false, false, this.stacked);
				}
				
			} else if(this.tabIndex == 12) {
				let prefix = 'AREA '
				a = 'legend'
				b = 'label'
				c = Rainbow
				let valuecol = 'PendapatanPTPR'

				if(this.area == 'area') {
					a = 'legend'
					b = 'label'
					valuecol = 'PendapatanPTPR' //Cnt
				}
				this.chartdata = this.processBarChart(this.reportdata.data, a, prefix, valuecol, false, b, "", 1, 2, c, false, false, false, this.stacked);		
			} else
				this.chartdata = this.processBarChart(this.reportdata.data, a, "", "SalesVolume", false, b, "", 1, 2, c, false, false, false, this.stacked);		
		},

		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabName == 'sales_volume') this.urlRequestParams+='/v1/fueljbt/monitoringSalesVolume?'
			else if (this.tabName == 'trans_count') this.urlRequestParams+='/v1/fueljbt/monitoringTransCount?'
			else if (this.tabName == 'latest_transaction') this.urlRequestParams+='/v1/fueljbt/latestTransaction?'

			//this.urlRequestParams+='&date-range-start='+this.date.Start
			//this.urlRequestParams+='&date-range-end='+this.date.End

			//console.log('daterange: ' + this.dateRange)
			//console.log('this.dateRange[0]: ' + this.dateRange[0])
			//console.log('this.dateRange[1]: ' + this.dateRange[1])
			this.urlRequestParams +='&station='+this.stationid
			//this.urlRequestParams +='&counttrans='+this.countTrans
			this.urlRequestParams +='&area='+this.area
		
			this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')

			/*
			//if(this.monthRange[0] != 'undefined')
			this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

			//if(this.monthRange[1] != 'undefined')
			this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&plant='+this.plantno

			*/

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;
					
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})

        },

		applyFilter() {
			this.resumePilihan()
        },
		
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
	opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>